// Import Libs and Handlers
import React, { useEffect } from 'react';
import { injectStyle } from '../handlers/shared/injectStyle';
import { initComponentInstanceIndexMap } from '../handlers/shared/instanceMap';
import { setHtmlFontSize } from '../handlers/shared/setHtmlFontSize';

let ReactDOMServer;

// Global Style
injectStyle(`body {
	border: 1px none #161616 !important;
background-color: rgba(198,218,243,1) !important;
background-repeat: repeat-y !important;
background-size: auto !important;
background-position: center top !important;
}`, '__impage_injected-global-styles');

// Auto Inject Style
injectStyle(``, '__impage_injected-component-styles');

// Global Data
const meta = {
    "title": "免费抽iPhone",
    "desc": "【定向流量-天美周年庆】CF手游2023年12月活动",
    "start": new Date('Fri Dec 01 2023 13:53:07 GMT+0800 (China Standard Time)'),
    "end": new Date('Sun Dec 31 2023 13:53:07 GMT+0800 (China Standard Time)'),
    "actId": 110,
    "actKey": "lpf2soojhmxzfec",
    "containerType": "*",
    "isTemplate": false,
    "isEditor": false,
    "isTestEnv": false
};

const _global = {};

if (typeof window !== 'undefined') {
  // Inject Global
  if(!window['VISION']){
    Object.defineProperty(window, 'VISION', {
      value: { meta, global: _global },
      writable: false,
      configurable: false,
    });
  }
}

export default function App({ children }) {

  useEffect(()=>{
    setHtmlFontSize(window, document);
  },[]);

  return children({ global: _global, meta: meta });
}
